import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ClientShareApp } from "./app";
// Reuse the console's design tokens + self-hosted fonts + keyframes (spin,
// pop-in, etc.) verbatim so the client view is pixel-identical to the console.
import "../app/styles/base.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ClientShareApp />
  </StrictMode>,
);
